import { Component, inject, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormField, form } from '@angular/forms/signals';
import { ETipoDocumentoPromocion } from '@core/enums/tipoDocumentoPromocion.enum';
import { IOptionsSelect } from '@core/interfaces/options.select.interface';
import { ICrearPromocionImpresoraReq } from '@core/interfaces/request-response/promocion-impresora.dto.interface';
import { PromocionImpresoraApiService } from '@core/services/api/promocion-impresora-api.service';
import { ToastService } from '@shared/services/toast.service';
import { UiSelect } from '@shared/components/ui';
import { IPromocionImpresoraData } from '@core/interfaces/entidades/promocion-impresora.entidad';

@Component({
  selector: 'app-crear-promocion-impresora',
  imports: [FormField, UiSelect],
  templateUrl: './crear-promocion-impresora.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './crear-promocion-impresora.css',
})
export class CrearPromocionImpresora implements OnInit {
  ngOnInit(): void {
    this.tiposDocumento = Object.values(ETipoDocumentoPromocion);
    this.opcionesTipoDocumento.set(
      this.tiposDocumento.map((t) => ({ label: t === 'TODOS' ? 'Todos' : t, value: t })),
    );
  }
  private toastService = inject(ToastService);
  private api = inject(PromocionImpresoraApiService);

  tiposDocumento: ETipoDocumentoPromocion[] = [];
  opcionesTipoDocumento = signal<IOptionsSelect<ETipoDocumentoPromocion>[]>([]);
  formPromocion = form(
    signal({
      nombre: '',
      contenido: '',
      tipo_documento: ETipoDocumentoPromocion.TODOS,
      monto_minimo: null as number | null,
      activo: true,
    }),
  );
  cerrar = output<IPromocionImpresoraData | undefined>();

  cancelar() {
    this.cerrar.emit(undefined);
  }
  crear($event: Event) {
    $event.preventDefault();
    const formValue = this.formPromocion().controlValue();
		const dataToSave: ICrearPromocionImpresoraReq = {
			nombre: formValue.nombre,
			contenido: formValue.contenido,
			tipo_documento: formValue.tipo_documento,
			monto_minimo: formValue.monto_minimo,
			activo: formValue.activo,
		};
    this.api.crear(dataToSave).subscribe({
      next: (data) => {
        this.toastService.show(
          'top-right',
          'success',
          'Promoción',
          'Promoción creada correctamente.',
        );
        this.cerrar.emit(data);
      },
      error: (err) => {
        if (err.status == 401) return;
        this.toastService.show(
          'top-right',
          'error',
          'Promoción',
          err.error?.message || 'Error al crear la promoción.',
        );
      },
    });
  }
}
